import { Table, Card } from "antd";

export const ProductsTable = ({ data }) => {
  const columns = [
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      width: 150,
    },

    {
      title: "Categoria",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Marca",
      dataIndex: "brand",
      key: "brand",
    },

    {
      title: "Modelo",
      dataIndex: "model",
      key: "model",
    },

    {
      title: "Stock",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Talla",
      dataIndex: "size",
      key: "size",
    },

    {
      title: "Proveedor",
      dataIndex: "provider",
      key: "provider",
    },
    {
      title: "Precio de compra",
      dataIndex: "buyPrice",
      key: "buyPrice",
      render: (record) => `S/ ${record}`,
    },
    {
      title: "Precio de venta",
      dataIndex: "sellPrice",
      key: "sellPrice",
      render: (record) => `S/ ${record}`,
    },
  ];

  const totalWidth = columns.reduce((acc, column) => acc + (column.width || 150), 0);

  return (
    <Card title="Productos">
      <Table
        dataSource={data}
        columns={columns}
        scroll={{x: totalWidth, y: 230 }}
        pagination={false}
      />
    </Card>
  );
};
